import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { WebHeader } from './header/header';
import { WebFooter } from './footer/footer';

@Component({
  selector: 'app-web-layout',
  templateUrl: './web-layout.html',
  styleUrl: './web-layout.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet, WebHeader, WebFooter],
})
export class WebLayout {}
